import config from "./config";
import moment from "moment";
import { ShortCrypt } from "short-crypt";
import generatePDF, { Resolution, Margin } from 'react-to-pdf';

const shortCryptKey = "JwOwwUuFqcA9vEuZiBdT0w==";
const shortCrypt = new ShortCrypt(shortCryptKey);

const DEFAULT_PRIMARY_COLOR = "#209e7e";
const DEFAULT_SECONDARY_COLOR = "#fbfdff";
const DEFAULT_COLOR_HEADER = "#ecefe7";

export const encrypt = (plainText) => {
    let cipher = shortCrypt.encryptToURLComponent(plainText.toString());
    return cipher;
}
export const decrypt = (cipher) => {
    let decrypted = shortCrypt.decryptURLComponent(cipher);
    if (decrypted) {
        return new TextDecoder().decode(decrypted.buffer);
    }
    return null;
}


export const remoteEndPoint = function () {
    // return process.env.NODE_ENV === "development" ? config.SERVICE_END_POINT_DEV : config.SERVICE_END_POINT_PROD;

    return process.env.NODE_ENV === "development" ? "http://" + window.location.hostname : config.SERVICE_END_POINT_PROD;
}
const buildKey = (key) => {
    let prefix = "WLG_";
    if (process.env.NODE_ENV === "development") {
        prefix += "DEV_"
    }
    return prefix + key;
}
export const localdb = {
    put: (k, v) => {
        localStorage.setItem(buildKey(k), v)
    },
    get: (k) => {
        return localStorage.getItem(buildKey(k));
    },
    remove: (k) => {
        localStorage.removeItem(buildKey(k));
    },
    getKey: (k) => {
        return buildKey(k);
    }
}

const quiz_pin_name = "quiz_pin";
export const quizLocaldb = {
    getOrDefault: (k) => {
        let item = localdb.get(k);
        if (!item) {
            localdb.put(k, JSON.stringify({}));
            item = localdb.get(k);
        }
        return JSON.parse(item);
    },
    get: (pin) => {
        quizLocaldb.cleanUpParticipants(pin);
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        if (quizData) {
            return quizData[pin];
        }
    },
    add: (pin, participantObj) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        if (pin && participantObj.participantId && quizData) {
            let pinData = quizData[pin];
            if (!pinData) {
                quizData[pin] = {};
            }
            participantObj.addedOn = Date.now();
            quizData[pin][participantObj.participantId] = participantObj;
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    },

    cleanUpParticipants: async(pin) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        /*delete quizData[pin];
        localdb.put(quiz_pin_name, JSON.stringify(quizData));*/

        if (quizData && pin && quizData[pin]) {
            const quizParticipants = quizData[pin];
            let filteredParticipants = {};
            Object.keys(quizParticipants).forEach((key,index) => {
                const participant = quizParticipants[key];
                if (participant.addedOn && Date.now() - participant.addedOn <= 86400000) {
                    filteredParticipants[key] = participant;
                }
            })

            if (filteredParticipants && Object.keys(filteredParticipants).length > 0) {
                quizData[pin] = filteredParticipants;
            } else {
                delete quizData[pin];
            }
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    },

    remove: (pin, participantId) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        const pinData = quizData && quizData[pin];
        if (pin && participantId && pinData) {
            delete quizData[pin][participantId];
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    },
    removeAll: (pin) => {
        const quizData = quizLocaldb.getOrDefault(quiz_pin_name);
        const pinData = quizData && quizData[pin];
        if (pin && pinData) {
            delete quizData[pin];
            localdb.put(quiz_pin_name, JSON.stringify(quizData));
        }
    }
}

export const TOKEN_HEADER_KEY = "cu-access-token";

export const getAuthHeader = () => {
    var authHeader = {}
    authHeader[TOKEN_HEADER_KEY] = localdb.get(TOKEN_HEADER_KEY);
    return authHeader;
}

export const getAuthToken = () => {
    return localdb.get(TOKEN_HEADER_KEY);
}

export const uriAPI = () => {
    return remoteEndPoint() + getApiEndPoint();
}

const getApiEndPoint = () => {
    return process.env.NODE_ENV === "development" ? config.SERVICE_API_DEV : config.SERVICE_API_PROD;
}

const getMediaDownloadEndPoint = () => {
    return process.env.NODE_ENV === "development" ? config.MEDIA_API_DOWNLOAD_DEV : config.MEDIA_API_DOWNLOAD;
}


const getUriAdminReportDownloadEndPoint = () => {
    return process.env.NODE_ENV === "development" ? config.ADMIN_REPORT_API_DOWNLOAD_DEV : config.ADMIN_REPORT_API_DOWNLOAD;
}

export const uriMedia = () => {
    return remoteEndPoint() + getUriEndPoint();
}

export const uriAdminReport = () => {
    return remoteEndPoint() + getUriAdminReportDownloadEndPoint();
}

export const uriDownloadMedia = () => {
    return remoteEndPoint() + getMediaDownloadEndPoint();
}

const getUriEndPoint = () => {
    return process.env.NODE_ENV === "development" ? config.MEDIA_API_DEV : config.MEDIA_API_V1;
}

export const defaultPath = (permConfig) => {
    if (permConfig?.role) {
        let path = "/admin";
        if ("ADMIN" === permConfig?.role) {
            path += "/dashboard";
        } else if ("TEACHER" === permConfig?.role) {
            path += "/curriculums";
        }
        return path;
    }
    return "/";
}

export const displayName = (firstName, lastName) => {
    if (firstName && lastName) {
        return firstName + " " + lastName;
    }
    if (firstName) {
        return firstName;
    }
    if (lastName) {
        return lastName;
    }
}

export const formatSecondsToHHMMSS = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let formattedHours = String(hours).padStart(2, '0');
    let formattedMinutes = String(minutes).padStart(2, '0');
    let formattedSeconds = String(seconds).padStart(2, '0');
    let result = "";
    if (hours && hours > 0) {
        result = formattedHours + ":";
    }
    return result + formattedMinutes + ":" + formattedSeconds;
}

export const fullScreen = (elementId) => {
    const element = document.getElementById(elementId);
    if (!element) {
        return;
    }
    const isFullScreen = document.fullscreenElement;
    if (isFullScreen) {
        closeFullscreen();
    } else {
        openFullscreen(element);
    }
}

const openFullscreen = (elem) => {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
    }
}

const closeFullscreen = () => {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
    }
}

export const validateField = (layoutField, field) => {
    switch (layoutField.inputType.toUpperCase()) {
        case 'TEXT':
            return null;

        case 'TEXTAREA':
            return null;

        case 'DOCUMENT':
            if (![
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'text/rtf',
                'text/plain',
                'application/x-iwork-pages-sffpages',
                'application/x-iwork-numbers-sffnumbers',
                'application/x-iwork-keynote-sffkey'
            ].includes(field.type)) {
                return "Invalid format";
            }
            return null;
        case 'IMAGE':
            if (![
                'image/jpeg',
                'image/png',
                'image/gif',
                'image/bmp',
            ].includes(field.type)) {
                return "Invalid format";
            }
            return null;
        case 'AUDIO':
            if (![
                'video/ogg',
                'audio/mpeg',
                'audio/wav',
                'audio/aac',
                'audio/x-m4a',
                'audio/ogg'
            ].includes(field.type)) {
                return "Invalid format";
            }
            return null;
        case 'VIDEO':
            if (![
                'video/ogg',
                'video/mp4',
                'video/quicktime',
                'video/x-ms-wmv',
                'video/avi',
                'video/mpeg',
                'video/mpeg2'
            ].includes(field.type)) {
                return "Invalid format";
            }
            return null;

        case 'RADIO':
        case 'CHECK':
            return null;

        default:
            return "Invalid format";

    }

}


/**
 * 
 * @param {*} expiryDateStr =>Curriculum target date
 * @param {*} targetDateStr =>Lesson target date
 * @param {*} submittedDateStr =>Lesson submitted date
 * @returns {text, color, show}
 */
export const ribbonProps = (expiryDateStr, targetDateStr, submittedDateStr) => {
    let props = { text: "", color: "", show: false };

    let expiryDate = dateUtil.formatDate(expiryDateStr);
    let targetDate = dateUtil.formatDate(targetDateStr);
    let submittedDate = dateUtil.formatDate(submittedDateStr);

    if (!expiryDate || !targetDate) {
        return props;
    }

    //case : Expired and not submitted
    if (!submittedDate && dateUtil.isPastDate(expiryDate)) {
        props.text = "Expired";
        props.color = "grey";
        props.show = true;
        return props;
    }
    //cas : not submitted
    if (!submittedDate) {
        props.text = "Pending";
        props.color = "pink";
        props.show = true;
        return props;
    }
    //case : late submission
    if (submittedDate && dateUtil.daysBetween(targetDate, submittedDate) > 0) {
        props.text = "Delayed";
        props.color = "volcano";
        props.show = true;
        return props;
    } else {//case On time
        props.text = "On Time";
        props.color = "green";
        props.show = true;
        return props;
    }
}

export const dateUtil = {

    isPastDate: (dateIn) => {
        let dateToday = dateUtil.formatDate(new Date());
        return dateIn && dateUtil.daysBetween(dateIn, dateToday) > 0
    },
    formatDate: function (date, format = 'DD MMM, YYYY HH:mm') {
        if (!date) {
            return null;
        }
        let strDate = moment(date).format(format);
        if (strDate === "Invalid date") {
            return null;
        }
        return strDate;
    },

    formatDateOnly: function (date) {
        if (!date) {
            return null;
        }
        let momentDate = moment(date).format('LL');
        if (momentDate === "Invalid date") {
            return null;
        }
        return momentDate;
    },
    daysBetween: (targetDate, submittedDate) => {
        if (!targetDate || !submittedDate) {
            return;
        }
        return moment(submittedDate).diff(moment(targetDate), 'days');
    },
    fromNow: (date) => {
        if (!date) {
            return null;
        }
        let serverUtcDate = moment.utc(date).toDate();
        let localDate = moment(serverUtcDate).local();
        let timeNow = localDate.fromNow();
        return timeNow;
    },
    getDate: (format = 'MM-DD-YYYY') => {
        let strDate = moment(new Date()).format(format);
        return strDate;
    }



}

export const statusCode = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    ALREADY_COMPLETED: 208,
    BAD_REQUEST: 400,
    AUTHENTICATION_REQUIRED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    PRECONDITION_REQUIRED: 428,
    INTERNAL_SERVER_ERROR: 500
}

export const authUtil = {
    getLink: (links, linkName) => {
        if (!links || !Array.isArray(links) || !linkName) {
            return null;
        }
        let link = links.filter((link) => link.name == linkName)[0];
        return link;
    },
    hasLink: (links, linkName) => {
        if (!links || !Array.isArray(links) || !linkName) {
            return false;
        }
        let resLinks = links.filter((link) => link.name == linkName)
        return resLinks.length > 0;
    }
}

export const paginatorUtil = {
    getParams: (paginatorConfig) => {
        if (!paginatorConfig || !paginatorConfig.pageNumber || !paginatorConfig.pageSize) {
            return "?limit=5&offset=0";
        }
        const offset = (paginatorConfig.pageNumber - 1) * paginatorConfig.pageSize;
        let queryStr = "?limit=" + paginatorConfig.pageSize + "&offset=" + offset;
        return queryStr;
    },
    getConfig: (config) => {
        if (!config) {
            return { pageNumber: 1, pageSize: 5 };
        }
        return config;

    }

}
const PhonePattern = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
export const validatorUtil = {
    isValidPhone: (phone) => {
        return PhonePattern.test(phone);
    }
}

export const themeUtil = {
    updateTheme: (themeConfig) => {
        const PRIMARY_COLOR = themeConfig && themeConfig.COLOR_PRIMARY ? themeConfig.COLOR_PRIMARY : DEFAULT_PRIMARY_COLOR;
        const COLOR_SECONDARY = themeConfig && themeConfig.COLOR_SECONDARY ? themeConfig.COLOR_SECONDARY : DEFAULT_SECONDARY_COLOR;
        const COLOR_HEADER = themeConfig && themeConfig.COLOR_HEADER ? themeConfig.COLOR_HEADER : DEFAULT_COLOR_HEADER;

        document.body.style.setProperty("--primary-color", PRIMARY_COLOR);
        document.body.style.setProperty("--primary-color-alert-success", PRIMARY_COLOR.concat('10'));
        document.body.style.setProperty("--focus-outline-color", PRIMARY_COLOR.concat('75'));

        document.body.style.setProperty("--secondary-color", COLOR_SECONDARY);

        document.body.style.setProperty("--header-color", COLOR_HEADER);

        document.body.style.setProperty("--color-blue", "#288bb1");

    },
    getPropertyColor: (property) => {
        return document.body.style.getPropertyValue(property);
    }
}

export const confettiUtil = {
    turnOn: (callBack) => {
        let collection = document.querySelectorAll(".card");
        for (let element of collection) {
            element.style.setProperty("position", "unset");
        }
        if (callBack) {
            callBack();
        }
    },
    turnOff: () => {
        let collection = document.querySelectorAll(".card");
        for (let element of collection) {
            element.style.setProperty("position", "relative");
        }
    }
}

export const exportToPdfOptions = () => {
    return {
        // default is `save`
        method: 'save',
        // default is Resolution.MEDIUM = 3, which should be enough, higher values
        // increases the image quality but also the size of the PDF, so be careful
        // using values higher than 10 when having multiple pages generated, it
        // might cause the page to crash or hang.
        resolution: Resolution.MEDIUM,
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: Margin.MEDIUM,
            // default is 'A4'
            //format: 'letter',
            // default is 'portrait'
            //orientation: 'landscape',
        },
        canvas: {
            // default is 'image/jpeg' for better size performance
            mimeType: 'image/png',
            qualityRatio: 1
        },
        // Customize any value passed to the jsPDF instance and html2canvas
        // function. You probably will not need this and things can break, 
        // so use with caution.
        overrides: {
            // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
            pdf: {
                compress: true
            },
            // see https://html2canvas.hertzen.com/configuration for more options
            canvas: {
                useCORS: true
            }
        },
        filename: 'enrollments.pdf',
    }
}

export const animateCSS = (element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = document.querySelector(element);

        node.classList.add(animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation();
            node.classList.remove(animationName);
            resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });

